export default "__VITE_PUBLIC_ASSET__d393cb4a__"